import React from 'react';

interface ScaleDocumentIconV2Props {
  style?: React.CSSProperties;
}

const ScaleDocumentIconV2: React.FC<ScaleDocumentIconV2Props> = ({ style }) => {
  return <img style={style} src="/static/images/scale-document.png" />;
};

export default ScaleDocumentIconV2;
